<template>
  <div id="cache-control" />
</template>

<script>
import startWorker from "@/registerServiceWorker";

export default {
  name: "CacheControl",
  mounted() {
    startWorker();
  }
};
</script>
